import React from 'react'
import './Button.scss'

function Button({children}){
return <p className="primary_button">{children}</p>
}

export default Button